import { ThunkAPI } from '../rootReducer';
import { SERVICES, HttpMethods } from '../../services/api';
import { createAsyncThunk, AsyncThunk } from '@reduxjs/toolkit';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { showErrorMessage, showSuccessMessage } from '../notifications/index';
import { userLogout } from '../auth/login.thunks';

export const requestAccountUpgrade: AsyncThunk<void, void, ThunkAPI> = createAsyncThunk(
  'UpgradeAccount',
  async (_, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, void>({
        endpoint: 'accounts/request-upgrade',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(_, thunk);
      thunk.dispatch(showSuccessMessage('We\'ve let your account manager know that you\'re ready to upgrade! They will reach out to you shortly to confirm your subscription details.'));
      thunk.dispatch(userLogout());
      return response;
    } catch (err) {
      thunk.dispatch(showErrorMessage(err as string || 'An error occurred requesting your upgrade'));
      return thunk.rejectWithValue(err);
    }
  }
);